<script lang="ts" setup>
import { useHead } from "@unhead/vue"
import { watch } from "vue"
import { useRouter } from "vue-router"
import { useGetEventVault } from "@/api"
import { WebsiteForm } from "@/components"
import { useConvertedRouteParam, useTranslation } from "@/composables"
import { SidebarHostEventLayout } from "@/layouts"
import { isEventWebsiteUrlModeEnabled } from "@/models"

definePage({
  meta: {
    requiresAuth: true,
  },
})

const { t } = useTranslation()
const router = useRouter()
const eventVaultId = useConvertedRouteParam("id", "/event/[id]/website/", value => Number(value))

const { data: eventVault } = useGetEventVault(eventVaultId, { include: ["website"] })

watch(eventVault, (vault) => {
  if (vault && !isEventWebsiteUrlModeEnabled(vault.eventVaultSettings?.eventWebsiteUrlMode)) {
    router.replace(`/event/${vault.id}`)
  }
}, { immediate: true })

useHead({
  title: t("website_page.title"),
})
</script>

<template>
  <SidebarHostEventLayout>
    <WebsiteForm />
  </SidebarHostEventLayout>
</template>
